import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { HubService } from '../home/hub.service';
import { SecurityDTO } from './security';


@Injectable({ providedIn: 'root' })
export class TileSecurityResolver  {

  private _ConfigService = inject(HubService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): SecurityDTO[] | Observable<SecurityDTO[]> | Promise<SecurityDTO[]> {
    return this._ConfigService.getAllOrgSecurity()
      .pipe(catchError(error => {
        console.log('tile security resolver error retrieving tile security: ${error}');
        return of(null);
      }));
  }

}
